import React, { useState, useEffect, Dispatch } from 'react'
import { Col, Row, Input, Button, Radio, Switch, Spin, message, Table, Space, Modal } from "antd"
import { getUserList, updateUser } from '../../api/User/User'
import type { RadioChangeEvent } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';

interface IUser {
  createdAt: string,
  email: string,
  firstname: string,
  lastname: string,
  disabled: boolean,
  role: string,
  _id: string
}

const ModifyUser = (props: { setUpdateList: Dispatch<boolean>, updateList: boolean }) => {
  const [loadingValidate, setLoadingValidate] = useState<boolean>(false)
  const [email, setEmail] = useState<string>("")
  const [user, setUser] = useState<IUser | undefined>(undefined)
  const [userType, setUserType] = useState<string>("operator")
  const [lastName, setLastName] = useState<string>('')
  const [firstName, setFirstName] = useState<string>("")
  const [disabled, setDisabled] = useState<boolean>(false)
  const [userList, setUserList] = useState<any[]>([])
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    getUsers()
  }, [])

  useEffect(() => {
    if (props.updateList) {
      props.setUpdateList(false)
      getUsers()
    }
  }, [props.updateList])

  const getUsers = async () => {
    setLoading(true)
    const res = await getUserList(undefined, undefined)
    setUserList(res)
    setLoading(false)
  }

  const columns: ColumnsType<any> = [
    {
      title: 'Nom',
      dataIndex: 'lastname',
      key: 'lastname',
      render: text => <p>{text}</p>,
    },
    {
      title: 'Prenom',
      dataIndex: 'firstname',
      key: 'firstname',
      render: text => <p>{text}</p>
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: text => <p>{text}</p>,
    },
    {
      title: 'Groupe',
      dataIndex: 'role',
      key: 'role',
      render: text => <p>{text === 'admin' ? 'Administrateur' : "Operateur"}</p>,
    },
    {
      title: 'Actif',
      dataIndex: 'disabled',
      key: 'disabled',
      render: text => <p>{text ? "Désactivé" : "Actif"}</p>
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button onClick={() => handleEditUser(record)}>Modifier</Button>
        </Space>
      ),
    },
  ];

  const handleEditUser = (record) => {
    console.log(record)
    setEmail(record.email)
    setFirstName(record.firstname)
    setLastName(record.lastname)
    setDisabled(!record.disabled)
    setUserType(record.role)
    setUser(record)
    setOpenModal(true);
  }

  const onChangeType = (e: RadioChangeEvent) => {
    setUserType(e.target.value)
  }

  const validate = async (id: string) => {
    setLoadingValidate(true)
    const res = await updateUser(email, firstName, lastName, userType, !disabled, id)
    if (res) {
      message.success({ content: "L'utilisateur " + email + " a été mis à jour", duration: 5 });
    }
    setLoadingValidate(false)
    setOpenModal(false)
    getUsers()
  }

  return (
    <div className='modify-user-container'>
      <Row className='modify-user-row' >
        <Col md={24} className='modify-change lastname'>
          <Spin spinning={loading} indicator={<LoadingOutlined />}>
            <Table columns={columns} dataSource={userList}
              rowKey={(record) => record._id}
              pagination={{
                itemRender(_page, type, element) {
                  if (type === 'prev') return <Button className='rounded-button'>Précédent</Button>
                  if (type === 'next') return <Button className='rounded-button'>Suivant</Button>
                  return element
                }
              }} />
          </Spin>
        </Col>
      </Row>
      <Modal open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={
          <>
            <Button size='large' onClick={() => setOpenModal(false)}>Annuler</Button>
            <Button className='add-user-button' disabled={loadingValidate} size='large' onClick={() => validate(user?._id)}>
              <Spin indicator={<LoadingOutlined />} spinning={loadingValidate}>
                Valider
              </Spin>
            </Button>
          </>
        }>
        <Row>
          <Col md={12} className='modify-change lastname'>
            <p>Nom</p>
            <Input size='large' placeholder='Nom' defaultValue={user?.lastname} value={lastName} onChange={(event) => setLastName(event.target.value)} />
          </Col>
          <Col md={12} className='modify-change firstname'>
            <p>Prénom</p>
            <Input size='large' placeholder='Prenom' defaultValue={user?.firstname} value={firstName} onChange={(event) => setFirstName(event.target.value)} />
          </Col>
          <Col md={24} className='modify-change'>
            <p>Email</p>
            <Input size='large' placeholder='Email' defaultValue={user?.email} value={email} onChange={(event) => setEmail(event.target.value)} />
          </Col>
          <Col xs={24} className='create-user-radio'>
            <Radio.Group size='large' onChange={onChangeType} value={userType} defaultValue='user' >
              <Radio value={"user"} defaultChecked={true} className='create-user-radio-button'>Operateur</Radio>
              <Radio value={"admin"} className='create-user-radio-button'>Administrateur</Radio>
            </Radio.Group>
          </Col>
          <Col xs={24} className='create-user-radio'>
            <div className='modify-status'>Statut du compte:</div>
          </Col>
          <Col xs={24} className='create-user-radio'>
            <Switch className='modify-switch' onChange={checked => setDisabled(checked)} checked={disabled} checkedChildren="Actif" unCheckedChildren="Desactivé" />
          </Col>
        </Row>
      </Modal>
    </div >
  )
}

export default ModifyUser